// TODO: type this — Konva line shape type
type KonvaLine = any;

interface DrawingState {
    active: boolean;
    receivedLines: Record<string, KonvaLine[]>;
    drawerLastActive: Record<string, number>;
    drawingColors: string[];
    activeColor: string;
    brushSizes: number[];
    activeBrushSize: number;
    brushRenderSizeModifier: number;
}

// TODO: type this — Vuex action context (includes rootState)
type Ctx = any;

const DrawingStore = {
    namespaced: true,
    state: {
        active: false,
        receivedLines: {} as Record<string, KonvaLine[]>,
        drawerLastActive: {} as Record<string, number>,
        drawingColors: ['#d8d8f6', '#21a0a0', '#1ba73e', '#8b2635', '#c02d0c', '#f18701', '#002e3d'],
        activeColor: '#d8d8f6',
        brushSizes: [5, 10, 15],
        activeBrushSize: 5,
        brushRenderSizeModifier: 5,
    },
    mutations: {
        randomActiveColor(state: DrawingState): void {
            state.activeColor = state.drawingColors[Math.floor(Math.random() * state.drawingColors.length)];
        },
        toggle(state: DrawingState): void {
            state.active = !state.active;
        },
        updateColor(state: DrawingState, color: string): void {
            state.activeColor = color;
        },
        updateBrushSize(state: DrawingState, size: string): void {
            state.activeBrushSize = parseInt(size) - state.brushRenderSizeModifier;
        },
        addLine(state: DrawingState, line: KonvaLine): void {
            if (state.receivedLines[line.attrs.name] === undefined) {
                state.receivedLines[line.attrs.name] = [];
            }
            state.receivedLines = {
                ...state.receivedLines,
                [line.attrs.name]: [...state.receivedLines[line.attrs.name], line],
            };
        },
        markDrawerActive(state: DrawingState, userId: string): void {
            state.drawerLastActive[userId] = Date.now();
        },
        purgeUsersLines(state: DrawingState, userId: string): void {
            const receivedLines = { ...state.receivedLines };
            delete receivedLines[userId];
            state.receivedLines = receivedLines;
        },
        fadeUsersLines(state: DrawingState, userId: string): void {
            const drawerLastActive = { ...state.drawerLastActive };
            delete drawerLastActive[userId];
            state.drawerLastActive = drawerLastActive;
        },
        clearLines(state: DrawingState): void {
            state.receivedLines = {};
        },
    },
    actions: {
        toggle({ commit }: Ctx): void {
            commit('toggle');
        },
        updateColor({ commit }: Ctx, color: string): void {
            commit('updateColor', color);
        },
        updateBrushSize({ commit }: Ctx, size: string): void {
            commit('updateBrushSize', size);
        },
        drawLine({ commit, rootState }: Ctx, { mapId, line }: { mapId: string; line: KonvaLine }): void {
            commit('addLine', line);
            rootState.live.director.drawLine(mapId, line);
        },
        lineDrawReceived({ commit, rootState }: Ctx, { line }: { line: KonvaLine }): void {
            commit('markDrawerActive', line.attrs.name);
            if (rootState.profile.me.id !== line.attrs.name) {
                commit('addLine', line);
            }
        },
        purgeUsersLines({ commit }: Ctx, { userId }: { userId: string }): void {
            commit('purgeUsersLines', userId);
        },
        fadeUsersLines({ commit }: Ctx, { userId }: { userId: string }): void {
            commit('fadeUsersLines', userId);
        },
        clearLines({ commit }: Ctx): void {
            commit('clearLines');
        },
    },
};

export default DrawingStore;
